import { Injectable } from '@angular/core';
import { Platform } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { AlertService, DateTimeService } from '@shared';
import { differenceInCalendarDays } from 'date-fns';
import { TimeBombConstants } from './time-bomb.contants';

@Injectable()
export class TimeBombService {
	private alertId = 'TIME_BOMB_ALERT';
	public constructor(
		private dateTimeService: DateTimeService,
		private alertService: AlertService,
		private platform: Platform,
		private translateService: TranslateService
	) {}

	public init(): void {
		this.platform.resume.subscribe(async () => {
			await this.checkTimeBomb();
		});
	}

	public async checkTimeBomb(): Promise<void> {
		setTimeout(async () => {
			await this.alertService.dismissAlertById(this.alertId);

			const remainingDays = this.getRemainingActiveDays();
			if (remainingDays <= 0) {
				await this.alertService.presentAlertById(
					this.translateService.instant('timeBomb.timeReached'),
					[],
					this.alertId,
					false
				);
				return;
			}
			if (remainingDays <= TimeBombConstants.TIME_BOMB_THRESHOLD) {
				const message = this.translateService.instant('timeBomb.remainingDays', {
					daysUntilTimeBomb: remainingDays
				});
				const cancelButton = {
					text: '',
					handler: () => {}
				};
				const confirmButton = {
					text: this.translateService.instant('alert.buttons.confirm'),
					handler: () => {}
				};
				await this.alertService.presentAlertById(message, [cancelButton, confirmButton], this.alertId, false);
			}
		}, 1000);
	}

	public getRemainingActiveDays(): number {
		const currentDate = this.dateTimeService.getCurrentDateTime();
		const duration = differenceInCalendarDays(TimeBombConstants.TIME_BOMB_DATE, currentDate);

		return duration;
	}
}
